import React from "react";
import Leto from "./pages/leto/Leto";
import "./PersonalizedLabels.css";

/**
 * Standalone personalized notebook-label generator.
 * No account, login, subscription, Pro, payment, or server access is required.
 * The label form validates its inputs and generates/downloads the PDF locally.
 */
export default function PersonalizedLabelsApp() {
  return (
    <div className="personalized-labels-app">
      <Leto />
    </div>
  );
}
